import CapitalGainAmountError from './CapitalGainAmountError';
class CapitalGainInvalidCrowdfundingPropertyID extends CapitalGainAmountError {
    propertyId;
    constructor(propertyId, options) {
        super('INVALID_CROWDFUNDING_PROPERTY_ID', options);
        this.propertyId = propertyId;
    }
}
export default CapitalGainInvalidCrowdfundingPropertyID;
